import { z } from 'zod';
import '@apexdesigner/schema-tools';
import {
  belongsTo,
  date,
  hasMany,
  references,
} from '@apexdesigner/schema-tools';

export const term = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    name: z.string().nullable().optional().describe('Name'),

    startDate: date()
      .nullable()
      .optional()
      .presentAs('date')
      .describe('Start Date'),

    endDate: date()
      .nullable()
      .optional()
      .presentAs('date')
      .describe('End Date'),

    timezone: z
      .string()
      .nullable()
      .optional()
      .presentAs('timezone')
      .describe('Timezone'),

    organizationId: z.number().hidden().describe('Foreign key to Organization'),

    customerAccountManagerId: z
      .number()
      .nullable()
      .optional()
      .presentAs('reference')
      .describe('Foreign key to User'),

    literacyManagerId: z
      .number()
      .nullable()
      .optional()
      .presentAs('reference')
      .describe('Foreign key to User'),

    siteLeaderId: z
      .number()
      .nullable()
      .optional()
      .presentAs('reference')
      .describe('Foreign key to User'),

    organization: belongsTo('Organization'),

    customerAccountManager: references('User'),

    literacyManager: references('User'),

    siteLeader: references('User'),

    selectedStudents: hasMany('SelectedStudent'),

    alternateStudents: hasMany('AlternateStudent'),

    termTutors: hasMany('TermTutor'),

    times: hasMany('TermTime'),

    notAvailables: hasMany('NotAvailable'),

    testResults: hasMany('TestResult'),
  })
  .describe(
    'One tutoring period at an organization, with start and end dates and the\naccount-manager, literacy-manager, and site-leader contacts.',
  )
  .as('Term');

export { term as termSchema };
